import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlSecondaryMessage = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <RichTextField
      addButtonText="Add Secondary Message"
      form={props.form}
      label="Secondary Message"
      name="messagingSecondary"
      userPermissions={props.userPermissions}
      withAdd
    />
  </BorderedBlock>
);
